import React, { Fragment } from "react";
import styled from "styled-components";
import { Button } from "../../../components";
import { _O } from "../../../modules/utils";
import { IC } from "../../../resources/Assets";
import { BackgroundDiv, HeaderTitle, NoticeText } from "./ReceiptStyle";
import { ScrollToTop } from "../../common/ScrollToTop/ScrollToTop";
import useTitle from "../../../modules/hooks/useTitle";

const NftfGuide = props => {
  useTitle("진료예약_비대면_가이드");
  const nextBtnEvent = () => {
    _O.Open("/nftf/index/" + sessionStorage.getItem("receiptData"));
  };

  return (
    <Fragment>
      <ScrollToTop />
      <BackgroundDiv>
        <HeaderTitle>
          <div
            style={{ width: "40px", height: "40px" }}
            onClick={() => {
              _O.Open(sessionStorage.getItem("backUrl"));
            }}>
            <img src={IC.etc.ICON_CHEVRON_LEFT} />
          </div>
          <div>비대면 진료 예약 안내</div>
          <div style={{ width: "40px", height: "40px" }}>
            {/* <img src={ArrowLeft} /> */}
          </div>
        </HeaderTitle>

        <Body>
          <NoticeText>
            비대면 진료 예약은 <br /> 이렇게 진행됩니다
          </NoticeText>

          {/* image paddingTop 8px */}
          {/* image paddingTop 8px */}
          <Content>
            <ContentHeader>
              <Number>1</Number>
              <ContentHeaderTitle>
                예약하려는 병원을 찾아 선택해주세요
              </ContentHeaderTitle>
            </ContentHeader>
            <ContentBodyImage>
              <img
                src={IC.nftfGuide.ICON_NFTF_GUIDE_1}
                style={{ width: "100%" }}
              />
            </ContentBodyImage>
          </Content>

          <Content>
            <ContentHeader>
              <Number>2</Number>
              <ContentHeaderTitle>
                진료시간과 신분증, 카드정보를 입력해주세요
              </ContentHeaderTitle>
            </ContentHeader>
            <ContentBodyImage>
              <img
                src={IC.nftfGuide.ICON_NFTF_GUIDE_2}
                style={{ width: "100%" }}
              />
            </ContentBodyImage>
            <div>
              <ContentBodyText>
                <span>·</span>
                <span>
                  비대면 진료시 진료비가 상승할 수 있습니다. 또한 비대면 진료에
                  대한 케어포미 수수료가 함께 청구됩니다.
                </span>
              </ContentBodyText>
              <ContentBodyText>
                <span>·</span>
                <span>
                  병원 내부 상황에 따라, 진료 시간이 늦어지거나 예약 접수가
                  반려될 수 있습니다.
                </span>
              </ContentBodyText>
            </div>
          </Content>

          <Content>
            <ContentHeader>
              <Number>3</Number>
              <ContentHeaderTitle>
                예약이 진행되면 알림톡이 전송됩니다
              </ContentHeaderTitle>
            </ContentHeader>
            <ContentBodyImage>
              <img
                src={IC.nftfGuide.ICON_NFTF_GUIDE_3}
                style={{ width: "100%" }}
              />
            </ContentBodyImage>
          </Content>

          <Content>
            <ContentHeader>
              <Number>4</Number>
              <ContentHeaderTitle>
                시간에 맞춰 비대면 진료실에 입장해주세요
              </ContentHeaderTitle>
            </ContentHeader>
            <ContentBodyImage>
              <img
                src={IC.nftfGuide.ICON_NFTF_GUIDE_4}
                style={{ width: "100%" }}
              />
            </ContentBodyImage>
          </Content>

          <Content>
            <ContentHeader>
              <Number>5</Number>
              <ContentHeaderTitle>
                의사선생님께 자세한 증상을 이야기해주세요
              </ContentHeaderTitle>
            </ContentHeader>
            <ContentBodyImage>
              <img
                src={IC.nftfGuide.ICON_NFTF_GUIDE_5}
                style={{ width: "100%" }}
              />
            </ContentBodyImage>
            <ContentBodyText>
              <span>· </span>
              <span>
                의사의 판단에 따라, 비대면 진료를 중단하고 병원에 직접
                방문해야하는 경우가 생길 수 있습니다. 이 경우에도 기본 진료비가
                청구됩니다.
              </span>
            </ContentBodyText>
          </Content>
        </Body>

        <div
          style={{
            position: "fixed",
            width: "calc(100% - 40px)",
            padding: "24px 20px",
            bottom: "0px",
            display: "flex",
            gap: "24px",
            flexFlow: "column",
            background:
              "linear-gradient(to bottom, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.7) 79%, #fff 58%)",
          }}>
          <Button
            severity="primary"
            disable="off"
            clickEvent={() => nextBtnEvent()}>
            다음
          </Button>
        </div>
      </BackgroundDiv>
    </Fragment>
  );
};

const Body = styled.div`
  align-self: stretch;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 40px;
  padding: 40px 20px;
  padding-bottom: 102px;
`;

const Content = styled.div`
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: 12px;
  padding: 0;
`;

const ContentHeader = styled.div`
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
  padding: 0;
`;

const Number = styled.div`
  width: 25px;
  height: 25px;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 5px;
  background-color: #48454d;

  font-family: Pretendard;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  color: #fff;
`;

const ContentHeaderTitle = styled.span`
  flex-grow: 1;
  font-family: Pretendard;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.32px;
  text-align: left;
  color: #333;
`;

const ContentBodyImage = styled.div`
  align-self: stretch;
  flex-grow: 0;
  border-radius: 10px;
  background-color: #f2f2f2;
`;

const ContentBodyText = styled.div`
  align-self: stretch;
  flex-grow: 0;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: -0.28px;
  text-align: left;
  color: #666;

  display: flex;
  gap: 4px;

  word-break: keep-all;
`;

export default NftfGuide;
